// types
import { ReportColumnDto } from 'src/api';
// constants
import { numberAggregationModels } from '../constants/aggregation-model/number';

export function DiscountChangeColumn(index: number) {
  const column = {
    field: 'discountChange',
    headerName: 'Discount Change',
    description: 'The discount change in the period',
    type: 'number',
    index,
    width: 200,
    groupable: true,
    availableAggregationFunctions: numberAggregationModels,
    headerAlign: 'center',
    valueFormatter: (value: any, row: any) => {
      if (value === undefined || value === null) {
        return null;
      }
      if (row.priceCurrency === undefined) {
        return `${(value ?? 0).toFixed(2)}`;
      }
      return `${(value ?? 0).toFixed(2)} ${row.priceCurrency}`;
    },
  } as ReportColumnDto<any, any, any>;
  return column;
}
